import { useWizard } from '@/components/mediaBuying/adCreatives/AdCreativeWizard'

export const IdentityBranding = () => {
    const { viewModel, setData, currentStepName } = useWizard()

    return (
        <div className="flex-grow-1 p-4 overflow-auto">
            <div className="d-flex gap-2">{currentStepName} Identity Branding</div>
        </div>
    )
}
